import React, { Component } from "react";
import "./Welcome.scss";
import { usingAPI } from "../Services/FetchService";

export default class Welcome extends Component {
    constructor() {
        super();
        this.state = {
            TopStory: null
        }
    }
    async componentDidMount() {
        let data = await usingAPI.getTopStory();
        this.setState({
            TopStory: data
        })
    }
    render() {
        const { TopStory } = this.state;
        if (TopStory == null) return (<div></div>);
        return (
            <section className="section section-welcome">
                <div className="padding">
                    <div className="container">
                        {/* תוצאות אמת  */}
                        <div className="candi-wrapper">
                            <div className="image"></div>
                        </div>
                        <a href={TopStory.Link} title={TopStory.Title} target="_self">
                            <div className="headline">
                                <div className="image" style={{
                                    backgroundImage: `url(${TopStory.Image.source})`
                                }}></div>
                                <div className="head">
                                    {TopStory.Title}
                                </div>
                                <div className="desc">
                                    {TopStory.Desc}
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Welcome/Welcome.jsx